import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";

interface Props {
  open: boolean;
  handleClose: () => void;
}

const UpgradeDialog = ({ open, handleClose }: Props) => {
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);
  const handleSubscribe = () => {
    setUpgradeDialogSource("Upgrade Offer Dialog");
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography variant="h6" textAlign="center">
          Upgrade Offer
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ textAlign: "center" }}>
          Pay $50 and receive 1 month of Bento's VA account (have someone do all
          the outreach for you).
        </Typography>
        <Grid container justifyContent="center" sx={{ my: 2 }}>
          <LoadingButton
            variant="contained"
            disableElevation
            onClick={handleSubscribe}
          >
            Subscribe
          </LoadingButton>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradeDialog;
